import { ModelBase } from '../abstract/model-base.model';

export class NotificationType extends ModelBase {

    static override CLASS_NAME: string = 'NotificationType';

    private _code!: string;
    private _label!: string;
    private _pushAvailable!: boolean;
    private _emailAvailable!: boolean;

    public get code(): string {
        return this._code;
    }

    public set code(value: any) {
        this._setValue('_code', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get pushAvailable(): boolean {
        return this._pushAvailable;
    }

    public set pushAvailable(value: any) {
        this._setValue('_pushAvailable', value, 'boolean');
    }

    public get emailAvailable(): boolean {
        return this._emailAvailable;
    }

    public set emailAvailable(value: any) {
        this._setValue('_emailAvailable', value, 'boolean');
    }

}
